export default __webpack_public_path__ + "static/media/ic_success_badge.13d22c6c.svg";